import UnleashedComponent from './UnleashedComponent';

export { UnleashedComponent };
